
import React, { useEffect, useRef, useState } from 'react';
import "./home.css";
import { useDispatch, useSelector } from 'react-redux';
import { Card, CloseButton, Col, Container, Form, Row, Toast } from 'react-bootstrap';
import { getCitiesList, getLocationByCityName, getLocationByLongAndLat } from '../../Redux/Action/LocationAction';
import WeatherCard from '../WeatherCard/WeatherCard';
import SearchComponent from '../SearchComponent/SearchComponent';

function Home() {

    const dispatch = useDispatch();

    const bannerRef = useRef();
    const crossRef = useRef();

    const userDetails = useSelector(state => state.userDetailsReducer);
    const locationDetails = useSelector(state => state.locationReducer);
    console.log("🚀 ~ Home ~ locationDetails:", locationDetails);


    const closeBanner = () => {
        bannerRef.current.style.display = 'none';
        crossRef.current.style.display = 'none';
    };

    const getDynamicClassName = () => {
        if (locationDetails?.currentLocationData?.weather?.[0].id >= 200 && locationDetails?.currentLocationData?.weather?.[0].id <= 299) {
            return 'weather-container-rainy';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id >= 300 && locationDetails?.currentLocationData?.weather?.[0].id <= 399) {
            return 'weather-container-rainy';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id >= 500 && locationDetails?.currentLocationData?.weather?.[0].id <= 599) {
            return 'weather-container-rainy';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id >= 600 && locationDetails?.currentLocationData?.weather?.[0].id <= 699) {
            return 'weather-container-snowy';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id >= 700 && locationDetails?.currentLocationData?.weather?.[0].id <= 799) {
            return 'weather-container-snowy';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id === 800) {
            return 'weather-container-sunny';
        } else if (locationDetails?.currentLocationData?.weather?.[0].id >= 801 && locationDetails?.currentLocationData?.weather?.[0].id <= 804) {
            return 'weather-container-rainy';
        }
    };

    const { wind, main, sys, visibility, name } = locationDetails.currentLocationData || {};

    return (
        <Row className="main-content-container">
            <Container sm={12} className='content-container pt-3'>

                <div className='position-relative' ref={crossRef}>
                    <CloseButton className='position-absolute' style={{ top: '25px', right: '10px' }} onClick={closeBanner} />
                </div>
                <div className='home-dashboard' ref={bannerRef}>
                    <h1 className='home-greeting'>
                        Hi <span className='home-greeting-username'>{userDetails.firstName} {userDetails.lastName}, </span>
                        <br />
                        <span>Welcome to Weather App.</span>
                    </h1>
                </div>

                {/* Search Component */}
                <Row className='dashboard-sc mt-3'>
                    <SearchComponent />
                </Row>

                {
                    Object.keys(locationDetails.currentLocationData).length > 0 &&


                    <div className={`weather-container ${getDynamicClassName()}`}>
                        <div className='d-flex flex-column align-items-center w-50' style={{ height: '200px' }}>
                            <img src={`https://openweathermap.org/img/wn/${locationDetails?.currentLocationData?.weather?.[0].icon}@2x.png`} width={100} height={100} />
                            <p className='m-0 p-0'>{Math.ceil(main?.temp - 273)} °C ({locationDetails?.currentLocationData?.weather?.[0]?.main})</p>
                            <p className='m-0 p-0 text-capitalize'>{locationDetails?.currentLocationData?.weather?.[0]?.description}</p>
                            <p className='m-0 p-0 home-cl' style={{ opacity: '0.5' }}>Current Location</p>
                            <p className='m-0 p-0 home-cl'>{name}, {sys?.country}</p>
                        </div>


                        <Row className='weather-cards-container'>
                            <WeatherCard details={{ name: "Wind", value1: `${Math.ceil((wind?.speed * 18) / 5)} KM/h` }} />
                            <WeatherCard details={{ name: "Humidity", value1: `${main?.humidity} %` }} />
                            <WeatherCard details={{ name: "Real Feel", value1: `${Math.ceil(main?.feels_like - 273)} °C` }} />
                            <WeatherCard details={{ name: "Pressure", value1: `${main?.pressure} hPa` }} />
                            <WeatherCard details={{ name: "Sea Level", value1: `${main?.sea_level} hPa` }} />
                            <WeatherCard details={{ name: "Ground Level", value1: `${main?.grnd_level} hPa` }} />
                            <WeatherCard details={{ name: "Visibility", value1: `${visibility} KM` }} />
                            <WeatherCard details={{ name: "Temperature History", value1: `Min: ${Math.ceil(main?.temp_min - 273)} °C`, value2: `Max: ${Math.ceil(main?.temp_max - 273)} °C` }} />
                        </Row>
                    </div>
                }

                {/* <Form.Group className='mt-3 w-25'>
                    <Form.Control className="todo-field" size="md" type="search" name={"search"} value={fields.search} onChange={handleChange} placeholder='Search Here' />
                </Form.Group> */}
            </Container>
        </Row>

    );
}

export default Home;